import React, { lazy } from "react"

/**
 * For using lazy loading with named exports.
 * Based on react-lazily.
 * @see https://github.com/JLarky/react-lazily
 *
 * Usage:
 * const { MyComponent } = lazily(() => import('./MyComponent'))
 */
export const lazily = <T extends {}, U extends keyof T>(loader: (x?: string) => Promise<T>) =>
    new Proxy({} as unknown as T, {
        get: (target, componentName: string | symbol) => {
            if (typeof componentName === "string") {
                return lazy(() =>
                    loader(componentName).then((x) => ({
                        default: x[componentName as U] as any as React.ComponentType<any>,
                    })),
                )
            }
            throw new Error(`lazily: component name must be a string, got ${typeof componentName} instead.`)
        },
    })
